// extracted by mini-css-extract-plugin
export default {"container":"NY-z","list":"OY-z"};